import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import { PageBase } from "app/components/Common/PageBase";
import {
  Box,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  Modal,
  Stack,
  Typography,
} from "@mui/joy";
import useStyleDashboardPage from "./utils/useStyleDashboardPage";
import HeaderTitle from "app/components/HeaderTitle/HeaderTitle";
import EnrollmentTutorialModal from "../../components/EnrollmentTutorialModal/EnrollmentTutorialModal";
import CalendarSchedule from "app/components/Calendar/CalendarSchedule";
import { ExamPage } from "../ExamPage/ExamPage";
import { ExamCard } from "app/components/ExamCard/ExamCard";
import useDashboardPage from "./utils/useDashboardPage";

export function DashboardPage() {
  const style = useStyleDashboardPage({});
  const {
    event,
    setEvent,
    examData,
    userCount,
    showUserCount,
    open,
    loading,
    hlQuota,
    slQuota,
    userInfo,
    showTutorialModal,
    handleTutorialModalClose,
  } = useDashboardPage({})


  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <PageBase>
        <Stack sx={style.main}>
          <Stack sx={style.content}>
            <Stack
              sx={style.header}
              direction={{ xs: 'column', md: "row" }}
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Stack>
                <Typography level="h1">Welcome!</Typography>
                <Typography>Get Started with your exam today.</Typography>
              </Stack>
              {showUserCount && (
                <Chip
                  size="md"
                  color="primary"
                  sx={{
                    bgcolor: 'background.surface',
                    padding: 2,
                    borderRadius: 16,
                  }}
                >
                  Registered Users : {userCount}
                </Chip>
              )}
            </Stack>
          
            {/* <Card sx={style.quotaCard}>
              <CardContent>
                <HeaderTitle
                  title="Exam Quota"
                  subtitle="🎓 Your Available Enrollments"
                />
                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                    <CircularProgress size="sm" />
                  </Box>
                ) : (
                  <Stack spacing={2} sx={{ mt: 2 }}>
                    <Stack spacing={1}>
                      <Stack 
                        direction="row" 
                        justifyContent="space-between" 
                        alignItems="center"
                        p={1}
                      >
                        <Typography level="title-md">Higher Level (HL) Exams:</Typography>
                        <Chip
                          size="md"
                          color={hlQuota > 0 ? "success" : "neutral"}
                          variant="soft"
                        >
                          {hlQuota} available
                        </Chip>
                      </Stack>
                      <Typography level="body-sm" sx={{ pl: 1, color: 'text.secondary' }}>
                        {userInfo?.purchasedHLQuantity || 0} purchased - {userInfo?.enrolledHLQuantity || 0} enrolled = {hlQuota} available
                      </Typography>
                    </Stack>
                    <Divider />
                    <Stack spacing={1}>
                      <Stack 
                        direction="row" 
                        justifyContent="space-between" 
                        alignItems="center"
                        p={1}
                      >
                        <Typography level="title-md">Standard Level (SL) Exams:</Typography>
                        <Chip
                          size="md"
                          color={slQuota > 0 ? "success" : "neutral"}
                          variant="soft"
                        >
                          {slQuota} available
                        </Chip>
                      </Stack>
                      <Typography level="body-sm" sx={{ pl: 1, color: 'text.secondary' }}>
                        {userInfo?.purchasedSLQuantity || 0} purchased - {userInfo?.enrolledSLQuantity || 0} enrolled = {slQuota} available
                      </Typography>
                    </Stack>
                  </Stack>
                )}
              </CardContent>
            </Card> */}
            
            {/* Upcoming Exam Card */}
            <Card sx={style.upcomingExam}>
              <CardContent>
                <ExamPage contentOnly={true} filterCountdown upcomingExam slQuota={slQuota} hlQuota={hlQuota} />
              </CardContent>
            </Card>
            
            {/* Calendar Card */}
            <Card sx={style.calendar}>
              <CardContent>
                <HeaderTitle
                  title="Exam Schedule"
                  subtitle="🎯 Stay Prepared"
                />
                <CalendarSchedule
                  events={examData}
                  onClickEventItem={async (value: any) => {
                    try {
                      setEvent((await value.value.examData))
                    }
                    catch (err) {
                    }
                  }}
                />
              </CardContent>
            </Card>
            
            {/* Modal for exam details */}
            <Modal
              open={open}
              onClose={() => setEvent(null)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Stack sx={{ maxWidth: '700px' }}>
                <ExamCard
                  exam={event}
                />
              </Stack>
            </Modal>
          </Stack>
        </Stack>
        <EnrollmentTutorialModal
          open={showTutorialModal}
          onClose={handleTutorialModalClose}
        />
      </PageBase>
    </CssVarsProvider>
  );
}
